<app-emu-input
  [value]="
    (nodeFromTreeRequest$ | async)
      ? ('TREE.SELECT_ON_TREE' | translate)
      : $safeNavigationMigration(rootItem?.item_name)
  "
  [name]="'ROOT ELEMENT'"
  [forceClearButton]="true"
  (cleared)="selectedItemCleared()"
  [readonly]="true"
  (click)="getNodeFromTree()"
></app-emu-input>

@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (addingItem !== null) {
  <section class="item-add-controls">
    <p>{{ 'TREE.SELECT_ON_TREE' | translate }}</p>
    <button class="button-primary" mat-flat-button (click)="addCustomItem()">
      <span>{{ 'DASHBOARD.OR_ADD_CUSTOM' | translate }}</span>
    </button>
    <button class="button-secondary" mat-flat-button (click)="cancelAddingItem()">
      <span>{{ 'BUTTON.CANCEL' | translate }}</span>
    </button>
  </section>
}

@if (structure) {
  <div class="structure-container">
    <app-sankey-chart-config-item
      [item]="structure"
      [isRoot]="true"
      (addItem)="addItem($event)"
      (addItemToParents)="addItemToParents($event)"
      (editItem)="editItem($event)"
      (addSeries)="addSeries($event)"
      (removeItem)="removeItem($event.parent, $event.item, $event.prop)"
      (removeSeries)="removeSeries($event.item, $event.series)"
    ></app-sankey-chart-config-item>
  </div>
}

<button
  class="button-primary apply-button"
  mat-flat-button
  [disabled]="!structure"
  (click)="applyDataToChart()"
>
  <span>{{ 'BUTTON.SAVE' | translate }}</span>
</button>
